module.exports = "//static.hsappstatic.net/livechat-unboxing-ui/static-1.6001/img/avatar.jpg"